import axios from 'axios';
import { showToast } from 'vant';
// 创建axios实例
const instance = axios.create({
  // 基础URL配置
  baseURL: import.meta.env.VITE_API_BASE_URL,
  // 请求超时时间
  timeout: 10000,
  // 请求头设置
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：添加token到请求头
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 可以在这里添加其他通用配置
    console.log('请求拦截器:', config);
    return config;
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data;
    
    // 根据后端返回的数据结构进行处理
    if (res.code !== 200) {
      // 显示错误提示
      showToast(res.message || '请求失败');
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    
    return res;
  },
  error => {
    // 处理响应错误
    console.error('响应错误:', error);
    
    // 根据错误状态码显示不同的提示
    if (error.response) {
      switch (error.response.status) {
        case 401:
          showToast('未授权，请重新登录');
          // 可以在这里处理登录跳转逻辑
          break;
        case 403:
          showToast('拒绝访问');
          break;
        case 404:
          showToast('请求地址不存在');
          break;
        case 500:
          showToast('服务器内部错误');
          break;
        default:
          showToast(`请求失败: ${error.response.status}`);
      }
    } else if (error.request) {
      showToast('网络错误，请检查网络连接');
    } else {
      showToast('请求配置错误');
    }
    
    return Promise.reject(error);
  }
);

// 导出常用请求方法
export default {
  // get请求
  get(url, params = {}) {
    params.firm_region_uuid = 1
    return instance.get(url, { params });
  },
  
  // post请求
  post(url, data = {}) {
    data.firm_region_uuid = 1
    return instance.post(url, data);
  },
  // 原始实例，方便使用其他方法
  instance
};